import { StrategicGoal } from './strategic-goal.model';
import { StrategicPerspective } from './strategic-perspective.model';
import { StrategicPillar } from './strategic-pillar.model';
import { StrategicValue } from './strategic-value.model';
import { StrategicSpecialValue } from './strategic-special-value.model';
// StrategicSpecialGoal is now unified with StrategicGoal

export interface StrategicPlan {
    id?: string;
    name?: string;
    nameAr?: string;
    nameEn?: string;
    type?: number;
    startYear: number;
    endYear: number;
    isActive?: boolean;
    vision?: string;
    visionAr?: string;
    visionEn?: string;
    mission?: string;
    missionAr?: string;
    missionEn?: string;
    pillars?: StrategicPillar[];
    goals?: StrategicGoal[];
    mapMode?: 'pillars' | 'perspectives' | 'both';
    perspectives?: StrategicPerspective[];
    values?: StrategicValue[];
    specialValues?: StrategicSpecialValue[];
    specialGoals?: StrategicGoal[];
    period?: string;
}

export interface PlanSummary {
    id: string;
    name: string;
    period: string;
}

export const specialPlanTypes = {
    internal: 1,
    external: 2,
} as const;
